
import React, { useEffect, useState } from 'react';

import ExternalConfiguration from '../../external-configuration';

// import './Wrapper-Bradmax.css';

const Constants = {
  PlayerId: 'Bradmax-player',
  PlayerScritpSrc: `${ExternalConfiguration.SelfHostedExternalSrcPaths.Bradmax}/player.js`,
};

const Globals = {
  playerScript: null,
  player: null,
};

const onLoad = (event, props) => {
  console.log( 'onLoad');
  console.log( 'event: ', event);
  console.log( 'props: ', props, props.contentData);
  console.log( 'window.bradmax: ', window.bradmax);
  const player_element = document.getElementById( Constants.PlayerId);
  window.bradmax.player.create( player_element, {
    dataProvider: {
      // skin: { theme: 'zebra' },
      source: [
        // { url: ExternalConfiguration.DefaultErrorVideo },
        { url: props.contentData.singleMedia.file },
      ],
      splashImages: [
        { url: props.contentData.singleMedia.image },
      ],
    },
  });
};

export default function Wrapper_Bradmax_player( props) {
  const { width, height } = props.bradmax_playerConfiguration?.customProps ?? {};
  const { PlayerId, PlayerScritpSrc } = Constants;
  const { player } = Globals;
console.log( 'render: ', width, height, player, player?.getWidth, player?.getHeight, player?.resize, props);
  if( player && (player.getWidth() !== width || player.getHeight() !== height)) player.resize( width, height);

  useEffect( () => {
    Globals.playerScript = document.createElement( 'script');
    Globals.playerScript.src = PlayerScritpSrc;
    Globals.playerScript.async = true;
    Globals.playerScript.onload = event => onLoad( event, props);
    document.head.append( Globals.playerScript );
  }, []);

  // console.log( 'components::Wrapper-Bradmax-player::render - props: ', props);    // DEVELOP
  return (
    <div className='wrapper-custom-3-s73-player-container' style={{ width: window.innerWidth, height: window.innerHeight }}>
      <div id={PlayerId} style={{ width: '100%', height: '100% '}}/>
    </div>
  );
}
